export const enum Color {
  // ALPHA
  WHITE_ALPHA_70 = '#ffffffb3',
  WHITE_ALPHA_50 = '#ffffff80',
  WHITE_ALPHA_40 = '#ffffff66',
  BLACK_ALPHA_70 = '#000000b3',
  BLACK_ALPHA_50 = '#00000080',
  PURPLE_500_ALPHA_20 = '#7650F833',
  // WHITE
  WHITE = '#fff',
  WHITE_100 = '#fffefe',
  // GRAY
  GRAY_100 = '#f7f9fc',
  GRAY_200 = '#F3F4F9',
  GRAY_300 = '#F2F3F5',
  GRAY_350 = '#e6e9f6',
  GRAY_400 = '#e9e9e9',
  GRAY_500 = '#ced4da',
  GRAY_600 = '#cacaca',
  GRAY_650 = '#bbbbbc',
  GRAY_700 = '#adb5bd',
  GRAY_750 = '#a9a9a9',
  GRAY_800 = '#7b8898',
  GRAY_850 = '#6c757d',
  GRAY_900 = '#626262',
  GRAY_920 = '#5c5c5c',
  GRAY_940 = '#4c4c4c',
  GRAY_950 = '#414040',
  // BLACK
  BLACK_100 = '#333',
  BLACK_200 = '#2f2e2e',
  BLACK_300 = '#2c3131',
  BLACK_400 = '#2b2b2c',
  BLACK_500 = '#272727',
  BLACK_600 = '#1e1e1f',
  BLACK_700 = '#220e0e',
  BLACK_800 = '#050506',
  BLACK = '#000',
  // BLUE
  BLUE_100 = '#79a5fe',
  BLUE_200 = '#5c73ff',
  BLUE_300 = '#5753fd',
  BLUE_400 = '#5162FF',
  BLUE_500 = '#384ed4',
  BLUE_600 = '#1f319b',
  BLUE_800 = '#280F8A',
  BLUE_850 = '#1F0C6B',
  BLUE_900 = '#17202a',
  // GREEN
  GREEN_300 = '#56e499',
  GREEN_400 = '#51cb83',
  // RED
  RED_100 = '#FFEAEC',
  RED_200 = '#ff7a50',
  RED_300 = '#FF754D',
  RED_400 = '#ff3e2d',
  RED_500 = '#f83b00',
  RED_600 = '#E74C3C',
  // PURPLE
  PURPLE_100 = '#e9e6ff',
  PURPLE_200 = '#ded1ed',
  PURPLE_300 = '#bd80ff',
  PURPLE_500 = '#7650F8',
  PURPLE_600 = '#7952D1',
  PURPLE_700 = '#724dca',
  // BROWN
  BROWN_100 = '#F7F5ED',
  BROWN_200 = '#F7EEE0',
  BROWN_300 = '#FFEBC0',
  BROWN_600 = '#8D5902',
  BROWN_700 = '#5b4f39',
  BROWN_800 = '#7d3603',
  BROWN_900 = '#452a00',
  BROWN_950 = '#40260B',
  // YELLOW
  YELLOW_100 = '#FFF4AC',
  YELLOW_200 = '#f9e167',
  YELLOW_300 = '#fdd33e',
  YELLOW_400 = '#ffc439',
  YELLOW_500 = '#ffb61f',
  YELLOW_600 = '#ffb00b',
}

export const COLORS = {
  TRANSPARENT: '#0000',
  WHITE: '#FFFFFF',
  BLACK: '#000000',

  BLACK_ALPHA_50: '#00000080',
  // PURPLE
  // PURPLE_100: '#e9e6ff',
  // PURPLE_200: '#ded1ed',
  // PURPLE_300: '#bd80ff',
  PURPLE_400: '#7879F2',
  PURPLE_100: '#E8D0F0',
  PURPLE_500: '#C479F2',
  PURPLE_700: '#7B00DA',

  // PURPLE_500: '#7650F8',
  // PURPLE_600: '#7952D1',
  // PURPLE_700: '#724dca',

  BLACK_300: '#2c3131',

  GRAY_30: '#E1E1E1',
  GRAY_100: '#EFF5F7',
  GRAY_400: '#cacaca',
  GRAY_700: '#626262',
} as const

export const BREAKPOINTS = {
  426: 426,
  375: 375,
  343: 343,
} as const

export const enum MediaBreakpoint {
  MIN_PHONE = 321,
  MEDIUM_PHONE = 375,
  MAX_PHONE = 441,
}

export const enum ViewportScrollPercentage {
  V_0 = 0,
  V_30 = 30,
  V_50 = 50,
  V_60 = 60,
  V_75 = 75,
  V_90 = 90,
  V_100 = 100,
}

export const DYNAMIC_DISCOUNT_THEME = {
  red: 'linear-gradient(87deg, #C40202 -4.33%, #FF5659 111.17%)',
  blue: 'linear-gradient(87deg, #7B00FF -3.7%, #1BE4FF 119.47%)',
  orange: 'linear-gradient(88deg, #FF0031 -0.53%, #FFBE1B 108.08%)',
}

export const DYNAMIC_DISCOUNT_TITLE_COLORS = {
  red: Color.RED_600,
  blue: '#0091ff',
  orange: Color.RED_500,
}
